<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WtY3I8/tc-custom/9781644030189.jpg?1729379484663" alt="This image is the cover for the book Doodle Stitching Embroidery Art"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Doodle Stitching Embroidery Art
      </h1>
      <p class="bookDescription body article font2">
        <b>Learn to use floss like a boss with these twenty original embroidery art projects, from the bestselling author of <i>Doodle Stitching </i>and <i>Patchwork Embroidery</i>.</b><br/><br/>Create one-of-a-kind embroidery art using simple techniques! Bestselling author Aimee Ray of Doodle Stitching fame is back with the fresh motifs and contemporary inspiration her fans have come to love. With Aimee’s help, you'll move beyond the pattern to reflect your artistic self?making hoop framed embroidery art, decorative keepsakes, pillows, patches, charms, and fabric scrapbooks. Create artwork you'll display in every room of the house! Mix and match motifs and personalize wall art with lettering and numbers. With twenty projects to personalize, <i>Doodle Stitching Embroidery Art </i>will intrigue both beginners and seasoned embroiderers.Sew 20 original embroidery art projects with bestselling author Aimee RayExpress your individuality with exciting ideas for beginners and skilled stitchersPersonalize your projects with fun embroidery motifs, words, and dates
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Aimée Ray
      </h2>
      
      <p class="authorDescription body article">Aimee Ray began embroidering at the age of five when her grandmother brought her a sampler. She picked it up again as an adult and found embroidering her own designs to be a fun and relaxing hobby. Today, hand embroidery is still her favorite pastime. Her previous eight Doodle Stitching books include The Motif Collection, Embroidered Woodland Creatures and The Christmas Collection Transfer Pack. Aimee lives with her husband and two children in Fayetteville, Arkansas. You can follow her work and find more of her original patterns and kits at aimeeray.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Published by C&T Publishing, Inc.,
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5b573a1a